import classNames from 'classnames';
import Link from '@alltrails/denali/components/Link';
import styles from './LinksColumn.module.scss';

type LinksColumnProps = {
  links: { label: string; href: string }[];
  seoTestAddTrailsToLocationLinks?: boolean;
  seoTestAddHikingTrailsToLocationLinks?: boolean;
};

const LinksColumn = ({ links, seoTestAddTrailsToLocationLinks, seoTestAddHikingTrailsToLocationLinks }: LinksColumnProps) => {
  let affix = '';
  if (seoTestAddTrailsToLocationLinks || seoTestAddHikingTrailsToLocationLinks) {
    affix = seoTestAddTrailsToLocationLinks ? ' trails' : ' hiking trails';
  }
  return (
    <ul>
      {links.map((link, index) => (
        <li
          key={link.label}
          className={classNames(styles.linkItem, {
            [styles.addPadding]: index !== 0,
            [styles.addPaddingTop]: index === 0,
            [styles.addPaddingBottom]: index === links.length - 1
          })}
        >
          <Link href={link.href} size="sm" noUnderline target="_blank" variant="secondary">
            {link.label}{affix}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default LinksColumn;
